// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"04767c74","223":"18c1ddfe","294":"78c28dbd","387":"d9b12c37","475":"fd60422e","604":"7ec609e6","751":"5ed0222f","994":"73a55abc"}[chunkId] + ".chunk.js";
};